import PlanogramService from '../../../services/planogram-service';
import {
    GET_PLANOGRAMS,
    GET_PLANOGRAM_SEARCH,
    UPDATE_LOADING_STATE as LIST_UPDATE_LOADING_STATE,
} from '../../type/planogram/planogram-type';
import {
    GET_PLANOGRAM,
    UPDATE_LOADING_STATE,
} from '../../type/planogram/edit-planogram-type';
import { error } from '../notifications';
import { getErrorMessage } from '../../../constants/utils';

const planogramService = new PlanogramService();

export const getPlanogramPage = (searchSpecificationModel) => {
    return async (dispatch) => {
        dispatch({ type: LIST_UPDATE_LOADING_STATE, payload: true });
        try {
            const planograms =
                await planogramService.getBySearchSpecificationModel(
                    searchSpecificationModel,
                );
            dispatch({
                type: GET_PLANOGRAM_SEARCH,
                payload: planograms,
            });
        } catch (e) {
            dispatch(updateError(e));
        } finally {
            dispatch({ type: LIST_UPDATE_LOADING_STATE, payload: false });
        }
    };
};
export const getPlanogram = (id) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_LOADING_STATE, payload: true });
        try {
            const planogram = await planogramService.getById(id);
            dispatch({ type: GET_PLANOGRAM, payload: planogram });
        } catch (e) {
            dispatch(updateError(e));
        } finally {
            dispatch({ type: UPDATE_LOADING_STATE, payload: false });
        }
    };
};
export const createEmptyPlanogram = () => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_LOADING_STATE, payload: true });
        dispatch({ type: GET_PLANOGRAM, payload: { isActive: true } });
    };
};

export const deletePlanogram = (id) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_LOADING_STATE, payload: true });
        let success = false;
        try {
            await planogramService.deleteById(id);
            success = true;
        } catch (e) {
            dispatch(updateError(e));
        } finally {
            dispatch({ type: UPDATE_LOADING_STATE, payload: false });
        }
        return success;
    };
};
export const savePlanogram = (id, planogram) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_LOADING_STATE, payload: true });

        try {
            if (id) {
                planogram = await planogramService.update(id, planogram);
            } else {
                planogram = await planogramService.create(planogram);
            }
            dispatch({ type: GET_PLANOGRAM, payload: planogram });
        } catch (e) {
            if (e.response.data) {
                if (
                    typeof e.response.data === 'object' &&
                    e.response.data.error
                ) {
                    dispatch(
                        updateMessageError(
                            'File upload failed, contact administrator',
                        ),
                    );
                } else {
                    dispatch(updateMessageError(e.response.data));
                }
            } else {
                dispatch(updateError(e));
            }
            dispatch({ type: UPDATE_LOADING_STATE, payload: false });
            throw e;
        }
        return planogram;
    };
};

const updateMessageError = (msg) => {
    return (dispatch) => {
        dispatch(error({ msg: msg, target: 'Retailer Group' }));
    };
};

const updateError = (errors) => {
    return (dispatch) => {
        dispatch(
            error({ msg: getErrorMessage(errors), target: 'Retailer Group' }),
        );
    };
};

export const clearPlanogram = () => {
    return async (dispatch) => {
        dispatch({ type: GET_PLANOGRAM, payload: undefined });
    };
};
export const clearPlanograms = () => {
    return async (dispatch) => {
        dispatch({ type: GET_PLANOGRAM_SEARCH, payload: undefined });
        dispatch({ type: GET_PLANOGRAMS, payload: undefined });
    };
};
